/*
 * @Author: Src
 * @Date: 2025-03-25 15:36:07
 * @LastEditTime: 2025-05-20 17:17:20
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/leadRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import Push from '@/views/lead/Push.vue';
import { AuthEnum } from '@/services/permission.service';

const leadRoutes: RouteConfig = {
  name: 'lead',
  path: '/lead',
  component: Main,
  redirect: {
    name: 'lead.push',
  },
  meta: {
    title: '品牌加盟线索',
  },
  children: [
    {
      name: 'lead.push',
      path: '/lead/push',
      component: Push,
      props: {
        auth: [AuthEnum.圈店推送],
      },
      meta: {
        title: '圈店发送',
      },
    },
  ],
};

export default leadRoutes;
